import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';

import Header from './layout/Header';
import Footer from './layout/Footer';
import Home from './Home';
import Contact from './Contact';
import About from './About';
import Career from './Career';
import MutualFundPage from './MutualFundPage';
import RetirementCalculator from './RetirementCalculator';
import LoanAgainstSecuritiesPage from './LoanAgainstSecuritiesPage';
import BondPage from './BondPage';
import AIFPage from './AifPage';
import ResearchAnalystPage from './ResearchAnalystPage';
import GlobalAccessPage from './GlobalAccessPage';
import CoreOfferings from './CoreOfferings';
import BlogHighlights from './BlogHighlights';
import ContactSection from './ContactSection';
import TestimonialSlider from './TestimonialSlider';
import Intro from './Intro';

function AppContent() {
  const location = useLocation();
  const [showDropdown, setShowDropdown] = useState(false);

  return (
    <>
      <Header showDropdown={showDropdown} setShowDropdown={setShowDropdown} />
      
      {/* Render Intro only on the home route */}
      {location.pathname === '/' && <Intro setShowDropdown={setShowDropdown} />}
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/MutualFundPage" element={<MutualFundPage />} />
        <Route path="/RetirementCalculator" element={<RetirementCalculator />} />
        <Route path="/LoanAgainstSecuritiesPage" element={<LoanAgainstSecuritiesPage />} />
        <Route path="/BondPage" element={<BondPage />} />
        <Route path="/AIFPage" element={<AIFPage />} />
        <Route path="/ResearchAnalystPage" element={<ResearchAnalystPage />} />
        <Route path="/GlobalAccessPage" element={<GlobalAccessPage />} />
        <Route path="/CoreOfferings" element={<CoreOfferings />} />
        <Route path="/BlogHighlights" element={<BlogHighlights />} />
        <Route path="/ContactSection" element={<ContactSection />} />
        <Route path="/TestimonialSlider" element={<TestimonialSlider />} />
      </Routes>
      
      <Footer />
    </>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;
